import { db } from '../../config/Fire';
import { setError } from './index';
import * as Constants from '../../constants';

export const SET_USER = 'SET_USER';

const setUser = payload => ({ type: SET_USER, payload });

export const setUserById = payload => {
    return dispatch => {
        return db.ref(`${Constants.MAIN_NODES.USERS}/${payload}`).once("value")
            .then((snapshot) => {
                if(snapshot.exists()) {
                    var user = snapshot.val();
                    if(user.userType) {
                        //Quedan separados los casos por si hay que agregar algo mas
                        switch (user.userType) {
                            case Constants.USER_TYPES.EMPLOYEE:
                                if(user.employeeCategories) {
                                    var promisesGetProcedures = [];
                                    var proceduresToUpdate = {};
                                    Object.keys(user.employeeCategories).forEach(categoryKey => {
                                        const refGetProcedures = db.ref(`${Constants.MAIN_NODES.PROCEDURES}`).orderByChild("employeeCategory").equalTo(`${categoryKey}`).once("value")
                                        .then(proceduresSnap => {
                                            if(proceduresSnap.exists()) {
                                                proceduresSnap.forEach(procedureSnap => {
                                                    const procedure = procedureSnap.val();
                                                    if(!procedure.employeeIds || !procedure.employeeIds[user.id] || procedure.employeeIds[user.id] !== true) {
                                                        proceduresToUpdate[procedure.id] = procedure;
                                                    }
                                                });
                                            }
                                        })
                                        promisesGetProcedures.push(refGetProcedures);
                                    });
                                    return Promise.all(promisesGetProcedures)
                                    .then(() => {
                                        if(Object.keys(proceduresToUpdate).length > 0) {
                                            var promisesUpdateProcedures = [];
                                            Object.keys(proceduresToUpdate).forEach(procedureKey => {
                                                const procedureToUpdate = proceduresToUpdate[procedureKey];
                                                if(!procedureToUpdate.employeeIds) {
                                                    procedureToUpdate.employeeIds = {};
                                                }
                                                procedureToUpdate.employeeIds[user.id] = true;
                                                const refUpdateProcedure = db.ref(`${Constants.MAIN_NODES.PROCEDURES}`).child(`${procedureKey}`).update(procedureToUpdate);
                                                promisesUpdateProcedures.push(refUpdateProcedure);
                                            });
                                            return Promise.all(promisesUpdateProcedures)
                                            .then(() => {
                                                dispatch(setUser(user));
                                                dispatch(setError({ state: false, rason: ""}));
                                            })
                                            .catch(() => {
                                                dispatch(setUser(user));
                                                dispatch(setError({ state: false, rason: ""}));
                                            })
                                        } else {
                                            dispatch(setUser(user));
                                            dispatch(setError({ state: false, rason: ""}));
                                        }
                                    })
                                    .catch(err => {
                                        dispatch(setUser(user));
                                        dispatch(setError({ state: false, rason: ""}));
                                    })
                                } else {
                                    dispatch(setUser(user));
                                    dispatch(setError({ state: false, rason: ""}));
                                }
                                break;
                            case Constants.USER_TYPES.ADMIN:
                            case Constants.USER_TYPES.CLIENT:
                            case Constants.USER_TYPES.REGISTER:
                                dispatch(setUser(user));
                                dispatch(setError({ state: false, rason: ""}));
                                break;
                            default:
                                dispatch(setError({ state: true, rason: "USER_NOT_AVAILABLE"}));
                                dispatch(setUser(null));
                                break;
                        }
                    } else {
                        dispatch(setError({ state: true, rason: "USER_NOT_AVAILABLE"}));
                        dispatch(setUser(null));
                    }
                } else {
                    console.log("snapshot: " + snapshot);
                    dispatch(setError({ state: true, rason: "USER_NOT_AVAILABLE"}));
                    dispatch(setUser(null));
                }
            })
            .catch(err => {
                console.log ('Error getting user: ', err);
                dispatch(setError({ state: true, rason: "USER_NOT_FOUND"}));
                dispatch(setUser(null));
            });
    };
};